/* eslint-disable */
export const balanceUser = (balanceLabel, hideLabel) => {
  return `${hideLabel ? '' : 'Saldo: '}${balanceLabel}`;
};
